import { render, staticRenderFns } from "./StartScreen.vue?vue&type=template&id=047d8378&scoped=true&"
import script from "./StartScreen.vue?vue&type=script&lang=js&"
export * from "./StartScreen.vue?vue&type=script&lang=js&"
import style0 from "./StartScreen.vue?vue&type=style&index=0&id=047d8378&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047d8378",
  null
  
)

component.options.__file = "StartScreen.vue"
export default component.exports